"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockExperimentVariant = void 0;
function mockExperimentVariant(overrides = {}) {
    return {
        name: 'mock experiment variant',
        id: 1,
        experiment_group_id_start: 0,
        experiment_group_id_end: 1000,
        slug: 'mock_experiment__mock_experiment_variant',
        ...overrides,
    };
}
exports.mockExperimentVariant = mockExperimentVariant;
